import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/inventory_/visual')({
  // ?donor= links created drafts to that donor; ?blueprint=1 pre-loads that
  // donor's typical-parts blueprint into the tray (M15).
  validateSearch: (search) => ({
    donor: typeof search.donor === 'string' ? search.donor : undefined,
    blueprint: search.blueprint ? 1 : undefined,
  }),
});
